/**
 * @typedef {(IDLE | START)} TypeAction An action.
 */

/**
 * The 'IDLE' action.
 * @type {'ACTION_IDLE'}
 * @constant
 */
const IDLE = 'ACTION_IDLE';

/**
 * The 'START' action.
 * @type {'ACTION_START'}
 * @constant
 */
const START = 'ACTION_START';

export {

    IDLE,
    START
};
